import { useContext, useEffect } from 'react';
import { useEditor, useNode } from '@craftjs/core';
import { OrganizationProvider } from '@/features/websites/components/OrganizationProvider';
import Menu from '@/components/menu/Menu';
import { CssClass } from '@/components/editor/settings/ClassSettings';
import { MenuItemsProps } from '../settings/MenuSettingsBlock';
import MenuBlockSettings from '@/components/menu/MenuBlockSettings';
import useResponsiveValues from '../hooks/useResponsiveValues';

interface Props extends CssClass, MenuItemsProps {
  //
}

const MenuBlock = (props: Props) => {
  const {
    connectors: { connect, drag },
    hasSelectedNode,
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });

  const responsive = useResponsiveValues();
  const { activeWebsite } = useContext(OrganizationProvider);
  const { query } = useEditor();

  const isEditorEnabled = query.getOptions().enabled;

  useEffect(() => {
    !hasSelectedNode;
  }, [hasSelectedNode]);

  if (!props.menuItems?.length && activeWebsite?.menu?.length)
    return <p ref={(ref: any) => connect(drag(ref))}>Menú Vacío</p>;

  return (
    <div
      ref={(ref: any) => connect(drag(ref))}
      className={`menu ${responsive.getValue(props.cssClass)}`}
    >
      <Menu
        menuItems={
          props?.useCustomNavigation
            ? props?.menuItems ?? []
            : activeWebsite?.menu ?? []
        }
        isEditor={isEditorEnabled}
      />
    </div>
  );
};

export default MenuBlock;

MenuBlock.craft = {
  displayName: 'Menú',
  props: {
    menuItems: [{ label: 'Inicio', url: '/' }],
  },
  related: {
    settings: MenuBlockSettings,
  },
};
